import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, styled, Typography, Box } from "@mui/material";
import { useState, FormEvent } from "react";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

interface UpdateDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

// Styled Dialog
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 1)", // Background color all black
  },
  "& .MuiDialog-paper": {
    backgroundColor: PureLightThemeCaaS.colors.alpha.white[100],
    borderRadius: PureLightThemeCaaS.general.borderRadius,
    padding: PureLightThemeCaaS.spacing(2),
    boxShadow: "none",
    //   width: "400px",
    //   height: "300px",
    overflow: "hidden", // Prevent scroll
    paddingBottom: "0px !important",
  },
}));

const StyledDialogContent = styled(DialogContent)({
  overflow: "hidden", // Remove scroll from content
  padding: "0px", // Adjust padding to maintain desired spacing
});


const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: PureLightThemeCaaS.colors.alpha.orange[100],
  color: PureLightThemeCaaS.colors.alpha.white[100],
  "&:hover": {
    backgroundColor: PureLightThemeCaaS.colors.alpha.orange[100],
  },
  padding: "3px",
}));

const ContentWrapper = styled(Box)({
  position: "relative",
  height: "100%",
});

const UpdateDialog = ({ open, onClose, onSubmit }: UpdateDialogProps) => {
  const handleSubmit = (e?: FormEvent) => {
    if (e) {
      e.preventDefault();
    }
    onSubmit();
  };

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <ContentWrapper>
        <DialogTitle sx={{ p: 0, fontSize: "20px", fontWeight: "bold", textAlign: "center" }}>Update Required</DialogTitle>
        <form onSubmit={handleSubmit}>
          <StyledDialogContent>
            <Typography sx={{ pt: 2, pb: 2, textAlign: "start", lineHeight: "1.2" }}>A new version of RotoGPT is available. Please update the app to continue.</Typography>
          </StyledDialogContent>
          <DialogActions sx={{ pt: 1, pb: 0, pl: 0, pr: 0, justifyContent: "center" }}>
            <StyledButton type="submit" sx={{ width: "50%" }}>
              Upgrade
            </StyledButton>
          </DialogActions>
        </form>
      </ContentWrapper>
    </StyledDialog>
  );
};

export default UpdateDialog;
